export default "__VITE_ASSET__bAot6umL__"